var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7807 15.5718H25.6231V14.3116C25.6231 13.4727 24.9935 12.7859 24.2217 12.7859H23.064V11.5257C23.064 10.6869 22.4344 10 21.6627 10H12.4014C11.6296 10.0019 11 10.6869 11 11.5276V23.9025C11 24.7414 11.6296 25.4282 12.4014 25.4282H13.559V26.6884C13.559 27.5273 14.1886 28.2141 14.9604 28.2141H16.1181V29.4743C16.1181 30.3131 16.7477 31 17.5195 31H26.7807C27.5525 31 28.1821 30.3151 28.1821 29.4743V17.0956C28.1821 16.2567 27.5525 15.5699 26.7807 15.5699V15.5718ZM13.559 14.3116V24.6317H12.4014C12.0358 24.6317 11.7312 24.3008 11.7312 23.9025V11.5276C11.7312 11.1294 12.0358 10.7984 12.4014 10.7984H21.6627C22.0282 10.7984 22.3329 11.1294 22.3329 11.5276V12.7878H14.9604C14.1886 12.7878 13.559 13.4727 13.559 14.3135V14.3116ZM16.1181 17.0956V27.4157H14.9604C14.5948 27.4157 14.2902 27.0847 14.2902 26.6865V14.3116C14.2902 13.9133 14.5948 13.5824 14.9604 13.5824H24.2217C24.5873 13.5824 24.8919 13.9133 24.8919 14.3116V15.5718H17.5195C16.7477 15.5718 16.1181 16.2567 16.1181 17.0975V17.0956ZM27.451 29.4705C27.451 29.8687 27.1463 30.1996 26.7807 30.1996H17.5195C17.1539 30.1996 16.8492 29.8687 16.8492 29.4705V17.0956C16.8492 16.6973 17.1539 16.3664 17.5195 16.3664H26.7807C27.1463 16.3664 27.451 16.6973 27.451 17.0956V29.4705Z",
    fill: "#201F20",
    stroke: "#201F20",
    strokeWidth: 0.381765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0781 18.5156H19.2289C19.0258 18.5156 18.8633 18.6926 18.8633 18.9139C18.8633 19.1351 19.0258 19.3121 19.2289 19.3121H25.0781C25.2812 19.3121 25.4437 19.1351 25.4437 18.9139C25.4437 18.7157 25.2609 18.5156 25.0781 18.5156Z",
    fill: "#201F20",
    stroke: "#201F20",
    strokeWidth: 0.381765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0781 21.4297H19.2289C19.0258 21.4297 18.8633 21.6067 18.8633 21.8279C18.8633 22.0492 19.0258 22.2262 19.2289 22.2262H25.0781C25.2812 22.2262 25.4437 22.0492 25.4437 21.8279C25.4437 21.6067 25.2609 21.4297 25.0781 21.4297Z",
    fill: "#201F20",
    stroke: "#201F20",
    strokeWidth: 0.381765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0781 24.3516H19.2289C19.0258 24.3516 18.8633 24.5286 18.8633 24.7498C18.8633 24.9711 19.0258 25.1481 19.2289 25.1481H25.0781C25.2812 25.1481 25.4437 24.9711 25.4437 24.7498C25.4437 24.5286 25.2609 24.3516 25.0781 24.3516Z",
    fill: "#201F20",
    stroke: "#201F20",
    strokeWidth: 0.381765
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0781 27.2578H19.2289C19.0258 27.2578 18.8633 27.4348 18.8633 27.6561C18.8633 27.8773 19.0258 28.0543 19.2289 28.0543H25.0781C25.2812 28.0543 25.4437 27.8773 25.4437 27.6561C25.4437 27.4348 25.2609 27.2578 25.0781 27.2578Z",
    fill: "#201F20",
    stroke: "#201F20",
    strokeWidth: 0.381765
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandout);
export default __webpack_public_path__ + "static/media/Handout.2aa111e3e7e037a815efd84c9ad7b651.svg";
export { ForwardRef as ReactComponent };